import { useTranslation } from 'react-i18next';

import { Button, Drawer } from '@/components';

import { CompanySchema } from '../../types';
import { AboutForm, AboutFormFields } from './about-form';

export type AboutDrawerProps = {
  readonly formId: string;
  readonly company: CompanySchema;
  readonly isOpen: boolean;
  readonly isLoading?: boolean;
  readonly onSubmit: (data: AboutFormFields) => void;
  readonly onClose: () => void;
};

export function AboutDrawer({ formId, company, isOpen, isLoading, onSubmit, onClose }: AboutDrawerProps) {
  const { t } = useTranslation(['settings']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary" disabled={isLoading}>
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('About')} open={isOpen} onClose={onClose} footer={footer}>
      <AboutForm id={formId} company={company} onSubmit={onSubmit} />
    </Drawer>
  );
}
